import { useIntl } from '@capsicum/common';
import { useCallback } from 'react';

import { fetchAgreementVersionActive } from '../data-access';

// It retrieves the global link of the terms and conditions
export const useTermsAndConditions = () => {
	const { getLocalizedField } = useIntl();

	return useCallback(async (): Promise<{ link?: string }> => {
		const userAgreement = await fetchAgreementVersionActive('user_agreement');

		const link = getLocalizedField('link', userAgreement || {});

		return { link };
	}, []);
};
